import Controller from '@ember/controller';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

export default class LoginController extends Controller {
  @service auth;
  @service router;

  @tracked accessCode = '';
  @tracked isSubmitting = false;
  @tracked errorMessage = null;

  @action
  updateCode(event) {
    // Convert to uppercase as user types
    this.accessCode = event.target.value.toUpperCase();
    this.errorMessage = null;
  }

  @action
  async submitCode(event) {
    event.preventDefault();

    const code = this.accessCode.trim();
    if (!code) {
      this.errorMessage = 'Please enter an access code';
      return;
    }

    this.isSubmitting = true;
    this.errorMessage = null;

    try {
      const isValid = await this.auth.login(code);

      if (isValid) {
        // Redirect to index
        this.accessCode = '';
        this.router.transitionTo('index');
      } else {
        this.errorMessage = this.auth.validationError || 'Invalid access code';
      }
    } catch (error) {
      console.error('[Login] Error:', error);
      this.errorMessage = 'An error occurred. Please try again.';
    } finally {
      this.isSubmitting = false;
    }
  }
}
